import http from "../../../../http";

const ShortAtcService =
    {
        getJsonData: async (FKey1, TableCode) => {
            const jsondata = await http.instance.get("/TechnicalHistory/JsonData/", {
                params: {
                    FKey1: FKey1,
                    TableCode: TableCode
                }
            })
            return jsondata.data;
        },
    };
export default ShortAtcService;

